import active from './active';
import defaultState from './default';
import disabled from './disabled';
import hover from './hover';

export default {
  active,
  default: defaultState,
  disabled,
  hover,
};
